import { css } from 'styled-components';
import { rem } from 'polished';

/**
 * @param  {} breakpoint
 * Example:
 * ${media(720px)`padding: 0 20px;`}
 */
export const media = (breakpoint) => (...args) => css`
  @media (max-width: ${rem(breakpoint)}) {
    ${css(...args)};
  }
`;
